// なりすましバーの platform_id をクリックでコピーする (manage / shops の両 pack から読む)
const FEEDBACK_MS = 2000;

function setupPlatformIdCopy() {
  const container = document.querySelector('[data-platform-id-copy]');
  if (!container) return;

  const button = container.querySelector('button');
  const icon = container.querySelector('[data-platform-id-copy-icon]');
  const status = container.querySelector('[data-platform-id-copy-status]');
  if (!button || !icon || !status) return;

  let resetTimer;

  const showResult = (iconClass, message) => {
    icon.classList.remove('fa-copy', 'fa-check', 'fa-xmark');
    icon.classList.add(iconClass);
    // alertify は shops の pack ではグローバルに無いので、結果はボタンと live region で伝える
    status.textContent = message;

    clearTimeout(resetTimer);
    resetTimer = setTimeout(() => {
      icon.classList.remove('fa-check', 'fa-xmark');
      icon.classList.add('fa-copy');
      status.textContent = '';
    }, FEEDBACK_MS);
  };

  button.addEventListener('click', async () => {
    // 値の一部をドラッグ選択したときも click が飛ぶので、選択範囲を全体で上書きしない
    const selection = window.getSelection();
    if (!selection.isCollapsed && container.contains(selection.anchorNode))
      return;

    try {
      await navigator.clipboard.writeText(container.dataset.platformIdCopy);
      showResult('fa-check', 'platform_id をコピーしました');
    } catch {
      // navigator.clipboard は非セキュアコンテキストでは未定義で、権限拒否で reject することもある
      showResult('fa-xmark', 'platform_id をコピーできませんでした');
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupPlatformIdCopy);
} else {
  setupPlatformIdCopy();
}
